<template>
    
    <div class="dialog-cover">
        
        <div class="dialog-content"> 
        </div>

        <img 
            :src="image.cancel"
            id="rd-cancel-btn"
            @click="closeRuleDialog"
        />
    </div>
</template>

<script>

    import { reactive, toRefs, getCurrentInstance } from "vue";

    import cancelBtn from "@/assets/ruledialog/cancel-btn.png";

    export default {
        name: "RuleDialog",
        setup() {

            const _this = getCurrentInstance().appContext.config.globalProperties;

            const state = reactive({
                image: {
                    cancel: cancelBtn
                }
            });

            const closeRuleDialog = () => {

                _this.$bus.$emit(_this.$constants.EVENT.RULE_DIALOG, {
                    type: _this.$constants.ENUM.RULE_DIALOG.CLOSE
                });
            }

            return {
                ...toRefs(state),
                closeRuleDialog
            }
        }
    };
</script>

<style lang="scss" scoped>

    .dialog-content {
        background-image: url(../assets/ruledialog/bg.png);
        background-position: 50% 50%;
        background-size: 100% 100%;
        position: fixed;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 20rem;
        height: 32rem;
    }

    #rd-cancel-btn {
        position: fixed;
        bottom: calc(100% - 40% - 20rem - 5%);
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2.7rem;
        height: auto;
    }
</style>